// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts"
// @generated from file events.proto (package nail2poll, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Event, EventPaginationResp, EventsList, EventsServiceCreateRequest, EventsServiceFilterReq, EventsServicePaginationReq, EventsServiceSearchAllReq, EventsServiceUpdateRequest } from "./events_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ActiveRequest, CountRequest, CountResponse, Identifier, IdentifierWithUserComment } from "./base_pb.js";

/**
 *
 * Describes the methods applicable on each event
 *
 * @generated from service nail2poll.EventsService
 */
export const EventsService = {
  typeName: "nail2poll.EventsService",
  methods: {
    /**
     * Create an event
     *
     * @generated from rpc nail2poll.EventsService.Create
     */
    create: {
      name: "Create",
      I: EventsServiceCreateRequest,
      O: Event,
      kind: MethodKind.Unary,
    },
    /**
     * Update an event
     *
     * @generated from rpc nail2poll.EventsService.Update
     */
    update: {
      name: "Update",
      I: EventsServiceUpdateRequest,
      O: Event,
      kind: MethodKind.Unary,
    },
    /**
     * Archive the event
     *
     * @generated from rpc nail2poll.EventsService.Archive
     */
    archive: {
      name: "Archive",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * Restore the event
     *
     * @generated from rpc nail2poll.EventsService.Restore
     */
    restore: {
      name: "Restore",
      I: IdentifierWithUserComment,
      O: Identifier,
      kind: MethodKind.Unary,
    },
    /**
     * View by UUID
     *
     * @generated from rpc nail2poll.EventsService.ViewByUUID
     */
    viewByUUID: {
      name: "ViewByUUID",
      I: Identifier,
      O: Event,
      kind: MethodKind.Unary,
    },
    /**
     * View all events
     *
     * @generated from rpc nail2poll.EventsService.ViewAll
     */
    viewAll: {
      name: "ViewAll",
      I: ActiveRequest,
      O: EventsList,
      kind: MethodKind.Unary,
    },
    /**
     * View events with pagination
     *
     * @generated from rpc nail2poll.EventsService.ViewWithPagination
     */
    viewWithPagination: {
      name: "ViewWithPagination",
      I: EventsServicePaginationReq,
      O: EventPaginationResp,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given search key
     *
     * @generated from rpc nail2poll.EventsService.SearchAll
     */
    searchAll: {
      name: "SearchAll",
      I: EventsServiceSearchAllReq,
      O: EventsList,
      kind: MethodKind.Unary,
    },
    /**
     * View all that match the given filter criteria
     *
     * @generated from rpc nail2poll.EventsService.Filter
     */
    filter: {
      name: "Filter",
      I: EventsServiceFilterReq,
      O: EventsList,
      kind: MethodKind.Unary,
    },
    /**
     * Count
     *
     * @generated from rpc nail2poll.EventsService.Count
     */
    count: {
      name: "Count",
      I: CountRequest,
      O: CountResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

